var _path, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMondialRelay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AC0148",
    d: "M512 472c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V40C0 17.9 17.9 0 40 0h432c22.1 0 40 17.9 40 40v432z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M210.3 444.5L136 399.8v-92S130.8 166.9 287.8 182v71.2s-78-10.4-78 52c-.1 62.3.5 139.3.5 139.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDC6BE",
    d: "M305.4 180.8h70.7v71.8h-70.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#CDC6BE",
    cx: 221.4,
    cy: 110.1,
    r: 42.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMondialRelay);
export default __webpack_public_path__ + "static/media/mondial_relay.f414d83d2d56635034efba6c1987bde9.svg";
export { ForwardRef as ReactComponent };